module.exports = __webpack_public_path__ + "img/StockSnap_XMVLGZZTW3.75461cf8.jpg";